import { OrderNotesSubFormType } from '@planning/pages/Order/V2/organisms/OrderNotesSubForm'
import { FormStore } from '@tom-ui/utils'
import { makeObservable } from 'mobx'

export type BulkEditOrderNotesFormStoreType = { ids: number[] } & OrderNotesSubFormType

export class BulkEditOrderNotesFormStore extends FormStore<BulkEditOrderNotesFormStoreType> {
  constructor() {
    super()

    makeObservable(this, {})
  }

  get data(): BulkEditOrderNotesFormStoreType {
    return {
      ...super.data,
    }
  }
}
